import { render, staticRenderFns } from "./ClientVisitList.vue?vue&type=template&id=1978610a&"
import script from "./ClientVisitList.vue?vue&type=script&lang=js&"
export * from "./ClientVisitList.vue?vue&type=script&lang=js&"
import style0 from "./ClientVisitList.vue?vue&type=style&index=0&id=1978610a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports